module.exports = __webpack_public_path__ + "static/img/nanya-plastics-mall-IMG.6e2c0a34.png";